/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown } from "rsuite";
import FileDownloadIcon from '@rsuite/icons/FileDownload';
import { Icon } from "@iconify/react";
import TableComponent from "components/common/tableComponent";
const ReportMarkdownDetailComponent = (props: any) => {
    const { clickedFilterData, clickedFilterDataMaster, tableDetails, reportList, exportToExcel, totalTableRow, DisplayNoDatatlabel, isTableCustomStriped, isTotalRowRequired } = props;

    return <>
        <div className="bg-container row m-0 mt-3 p-3">
            <div className="col-4 p-2 reportDescItem">
                <div className="icon">
                    <Icon icon="material-symbols:storefront-outline" />
                </div>
                <div className="label">
                    <p className="m-0">{"Store ID"}</p>
                    <p className="m-0">{clickedFilterDataMaster ? clickedFilterDataMaster.store_ID ?? 'All' : clickedFilterData ? clickedFilterData.store_ID === '' ? 'All' : clickedFilterData.store_ID : 'All'}</p>
                </div>
            </div>
            <div className="col-4 p-2 reportDescItem">
                <div className="icon">
                    <Icon icon="material-symbols:store-outline" />
                </div>
                <div className="label">
                    <p className="m-0">Department</p>
                    <p className="m-0">{clickedFilterData && (clickedFilterData.department ?? 'All').trim()}</p>
                </div>
            </div>
            <div className="col-3 p-2 reportDescItem">
            </div>
            <div className="col-1 p-2 reportDescItem">
                <div className="d-flex">
                    <Dropdown className="mx-2 button-fixed" title="Export" appearance="primary" placement="bottomEnd">
                        <Dropdown.Item icon={<FileDownloadIcon />}
                            onClick={() => {
                                exportToExcel(reportList, "Detailed Order Report");
                            }}
                        >Export to Excel
                        </Dropdown.Item>
                    </Dropdown>
                </div>
            </div>
        </div>
        <TableComponent isFromModal={true} tableDetails={tableDetails} reportList={reportList.sort((a, b) => { return a['store_ID'].toString().localeCompare(b['store_ID'].toString(), undefined, { numeric: true }) })} iconColumn={""} onTableRowClick={() => { }} totalTableRow={totalTableRow} isTotalRowRequired={isTotalRowRequired} DisplayNoDatatlabel={DisplayNoDatatlabel} isTableCustomStriped={isTableCustomStriped} />
    </>
};

export default ReportMarkdownDetailComponent;